import { render, staticRenderFns } from "./OrganizationCreate.vue?vue&type=template&id=19870bf6"
import script from "./OrganizationCreate.vue?vue&type=script&lang=ts"
export * from "./OrganizationCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports